import React from "react";

type BankTransferColorProps = React.SVGProps<SVGSVGElement>;

// "Überweisung" (bank transfer) is a payment method, not a brand — rendered as a
// bordered wordmark badge, matching RechnungColor.
const BankTransferColor: React.FC<BankTransferColorProps> = (props) => (
  <svg viewBox="0 0 132 32" role="img" fill="none" {...props}>
    <title>Überweisung</title>
    <rect
      x="1"
      y="1"
      width="130"
      height="30"
      rx="4"
      fill="#FFFFFF"
      stroke="#1A1918"
      strokeWidth="2"
    />
    <text
      x="66"
      y="21"
      textAnchor="middle"
      fontFamily="heebo, roboto, arial, helvetica, sans-serif"
      fontSize="15"
      fill="#1A1918"
    >
      Überweisung
    </text>
  </svg>
);

export default BankTransferColor;
